<template>
  <div class="cnehl-main" :style="{ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'}">
    
    <!-- Container 1 -->
    <div class="cn-report-container" :style="{
      'width': `${450 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${85 * zoomLevel}px`,
			'left': `${6 * zoomLevel}px`, }">
      
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Name</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cust Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Address<br>(Send To)</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Address}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Contact</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Tel</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Dest_tel}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Commodity</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Commodity'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Fwdg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Frt Forwarder Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cntr Opr</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContOperator'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Ref</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Cust Ref No'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Shipping Agt Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpr/Csgn</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu_name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Remarks</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Remarks'] }}</div>
      </div>
    </div>
    <div class="cn-report-container" :style="{
      'width': `${333 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${85 * zoomLevel}px`,
			'left': `${455 * zoomLevel}px`, }">
      <div class="reprint" :style="{
      'width': `${66 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      {@Reprint}
      </div>
      <div class="printed-on" :style="{
      'width': `${270 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${60 * zoomLevel}px`, }">
      PRINTED: {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy - HH:mm') }}
      </div>
      <div class="CDA" :style="{
      'width': `${190 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-11 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      CONTAINER DESPATCH ADVICE
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Consignment</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ConsignmentNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">{{ job['Job Type'] == 'E' ? 'Shpg Agt Ref' : job['Job Type'] == 'I' ? 'B/L No' : '' }}</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Job Type'] == 'E' ? job['Booking Ref No'] : job['Job Type'] == 'I' ? job['BL No'] : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Required Date</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy') : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Req Type</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['CN Job Type'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Container No</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContainerNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Size / Type</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContSize'] && cn['ContType'] ? `${cn['ContSize']} / ${cn['ContType']}` : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Handling Type</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['HandlingType'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Vessel</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Vessel No'] }} {{ job['Vessel Name'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">ETA</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['POD ETA'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Pick Up</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['PickUp'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Drop Off</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['DropOff'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Discharge Port</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['LoadDischargePort'] }}</div>
      </div>
      <div class="max-of-intDiversion1" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${178 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion1
    </div>
    <div class="max-of-intDiversion2" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${188 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion2
    </div>
    </div>
    <!-- Container 1 -->
    <!-- Container 2 -->
    <div class="cn-report-container" :style="{
      'width': `${450 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${350 * zoomLevel}px`,
			'left': `${6 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Name</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cust Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Address<br>(Send To)</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Address}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Contact</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Tel</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Dest_tel}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Commodity</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Commodity'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Fwdg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Frt Forwarder Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cntr Opr</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContOperator'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Ref</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Cust Ref No'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Shipping Agt Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpr/Csgn</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu_name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Remarks</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Remarks'] }}</div>
      </div>
    </div>
    <div class="cn-report-container" :style="{
      'width': `${333 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${350 * zoomLevel}px`,
			'left': `${455 * zoomLevel}px`, }">
      <div class="reprint" :style="{
      'width': `${66 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      {@Reprint}
      </div>
      <div class="printed-on" :style="{
      'width': `${270 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${60 * zoomLevel}px`, }">
      PRINTED: {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy - HH:mm') }}
      </div>
      <div class="CDA" :style="{
      'width': `${190 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-11 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      CONTAINER DESPATCH ADVICE
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Consignment</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ConsignmentNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">{{ job['Job Type'] == 'E' ? 'Shpg Agt Ref' : job['Job Type'] == 'I' ? 'B/L No' : '' }}</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Job Type'] == 'E' ? job['Booking Ref No'] : job['Job Type'] == 'I' ? job['BL No'] : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Required Date</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy') : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Req Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['CN Job Type'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Container No</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContainerNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Size / Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContSize'] && cn['ContType'] ? `${cn['ContSize']} / ${cn['ContType']}` : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Handling Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['HandlingType'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Vessel</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Vessel No'] }} {{ job['Vessel Name'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">ETA</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['POD ETA'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Pick Up</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['PickUp'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Drop Off</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['DropOff'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Discharge Port</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['LoadDischargePort'] }}</div>
      </div>
      <div class="max-of-intDiversion1" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${178 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion1
    </div>
    <div class="max-of-intDiversion2" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${188 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion2
    </div>
    </div>
    <!-- Container 2 -->
    <!-- Container 3 -->
    <div class="cn-report-container" :style="{
      'width': `${450 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${630 * zoomLevel}px`,
			'left': `${6 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Name</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cust Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Address<br>(Send To)</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Address}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Contact</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Tel</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Dest_tel}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Commodity</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Commodity'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Fwdg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Frt Forwarder Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cntr Opr</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContOperator'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Ref</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Cust Ref No'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Shipping Agt Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpr/Csgn</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu_name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Remarks</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Remarks'] }}</div>
      </div>
    </div>
    <div class="cn-report-container" :style="{
      'width': `${333 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${630 * zoomLevel}px`,
			'left': `${455 * zoomLevel}px`, }">
      <div class="reprint" :style="{
      'width': `${66 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      {@Reprint}
      </div>
      <div class="printed-on" :style="{
      'width': `${270 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${60 * zoomLevel}px`, }">
      PRINTED: {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy - HH:mm') }}
      </div>
      <div class="CDA" :style="{
      'width': `${190 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-11 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      CONTAINER DESPATCH ADVICE
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Consignment</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ConsignmentNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">{{ job['Job Type'] == 'E' ? 'Shpg Agt Ref' : job['Job Type'] == 'I' ? 'B/L No' : '' }}</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Job Type'] == 'E' ? job['Booking Ref No'] : job['Job Type'] == 'I' ? job['BL No'] : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Required Date</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy') : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Req Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['CN Job Type'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Container No</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContainerNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Size / Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContSize'] && cn['ContType'] ? `${cn['ContSize']} / ${cn['ContType']}` : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Handling Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['HandlingType'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Vessel</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Vessel No'] }} {{ job['Vessel Name'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">ETA</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['POD ETA'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Pick Up</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['PickUp'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Drop Off</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['DropOff'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Discharge Port</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['LoadDischargePort'] }}</div>
      </div>
      <div class="max-of-intDiversion1" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${178 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion1
    </div>
    <div class="max-of-intDiversion2" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${188 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      max-of-intDiversion2
    </div>
    </div>
    <!-- Container 3 -->
    <!-- Container 4 -->
    <div class="cn-report-container" :style="{
      'width': `${450 * zoomLevel}px`,
			'height': `${175 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${910 * zoomLevel}px`,
			'left': `${6 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Name</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cust Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Address<br>(Send To)</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Address}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Contact</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Tel</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Dest_tel}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Commodity</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Commodity'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Fwdg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Frt Forwarder Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cntr Opr</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContOperator'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Cust Ref</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Cust Ref No'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpg Agt</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Shipping Agt Name'] }}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Shpr/Csgn</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu_name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">Remarks</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['Remarks'] }}</div>
      </div>
    </div>
    <div class="cn-report-container" :style="{
      'width': `${333 * zoomLevel}px`,
			'height': `${210 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${910 * zoomLevel}px`,
			'left': `${455 * zoomLevel}px`, }">
      <div class="reprint" :style="{
      'width': `${66 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      {@Reprint}
      </div>
      <div class="printed-on" :style="{
      'width': `${270 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-20 * zoomLevel}px`,
      'left': `${60 * zoomLevel}px`, }">
      PRINTED: {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy - HH:mm') }}
      </div>
      <div class="CDA" :style="{
      'width': `${190 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${-11 * zoomLevel}px`,
      'left': `${0 * zoomLevel}px`, }">
      CONTAINER DESPATCH ADVICE
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Consignment</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ConsignmentNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">{{ job['Job Type'] == 'E' ? 'Shpg Agt Ref' : job['Job Type'] == 'I' ? 'B/L No' : '' }}</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Job Type'] == 'E' ? job['Booking Ref No'] : job['Job Type'] == 'I' ? job['BL No'] : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Required Date</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy') : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Req Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['CN Job Type'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Container No</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContainerNo'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Size / Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['ContSize'] && cn['ContType'] ? `${cn['ContSize']} / ${cn['ContType']}` : '' }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Handling Type</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['HandlingType'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Vessel</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['Vessel No'] }} {{ job['Vessel Name'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">ETA</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['POD ETA'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Pick Up</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['PickUp'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Drop Off</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ cn['DropOff'] }}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Discharge Port</div>
        <div class="colon" :style="{ 'padding': '0 8px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{{ job['LoadDischargePort'] }}</div>
      </div>
      <div class="max-of-intDiversion1" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${178 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      {Max of intDiversion1}
    </div>
    <div class="max-of-intDiversion2" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${8 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${188 * zoomLevel}px`,
			'left': `${1 * zoomLevel}px`, }">
      {Max of intDiversion2}
    </div>
    </div>
    <!-- Container 4 -->
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      job: {},
      cn: {},
      
      labelWidthLeft: 60,
      labelWidthRight: 75,
      rowPadding: 0,
      fontSize: 10
    }
  },
  props: {
    data: { type: Object, default: function() { return {}; }},
    printData: { type: Object, default: function() { return {}; }},

    properties: { type: Object, default: function() { return null; }},
    zoomLevel: { type: Number, default: 1 },
    fontPtPx: { type: Number, default: 1 },
    print: { type: Boolean, default: false },
  },
  methods: {
  },
  mounted() {
    this.job = this.properties['details'] ? this.properties['details'] : {};
    this.cn = this.properties['cns'] ? this.properties['cns'] : {};
  },
  watch: {
  }
}
</script>

<style scoped>
.cn-report-container { border: 1px solid gray; }
</style>